import OpenInFullIcon from "@mui/icons-material/OpenInFull";
import { LoadingButton } from "@mui/lab";
import { ReactNode } from "react";
import { useTranslation } from "react-i18next";

import styles from "./ChartContainer.module.scss";

interface ChartContainerProps {
    isBigChart: boolean;
    title?: string | undefined;
    children: ReactNode;
    onZoomClick?: () => void;
    showZoomButton?: boolean;
}

const ChartContainer = ({ isBigChart, title, children, onZoomClick, showZoomButton = true }: ChartContainerProps) => {
    const { t } = useTranslation();

    return (
        <div className={styles.chartGroup}>
            <div className={styles.chartHeader}>
                <div className={styles.chartTitle}>{t(title || "chart-name")}</div>
                {showZoomButton && onZoomClick && (
                    <LoadingButton startIcon={<OpenInFullIcon />} onClick={onZoomClick}></LoadingButton>
                )}
            </div>
            {isBigChart ? (
                <div className={styles.chartContainerLg}>{children}</div>
            ) : (
                <div className={styles.chartContainerSm}>{children}</div>
            )}
        </div>
    );
};

export default ChartContainer;
